export default __webpack_public_path__ + "27784f684234486f680a658fe7b59ca4.webp";